import axios from "axios";
import { API } from "./api";

export const TOKEN_KEY = "tg_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeader = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

// Redirect to login if the session expires while using the admin panel.
axios.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err.config?.url || "";
    if (err.response?.status === 401 && url.includes("/admin/") && !url.includes("/admin/login")) {
      clearToken();
      if (window.location.pathname.startsWith("/admin")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export const adminLogin = (email, password) =>
  axios.post(`${API}/admin/login`, { email, password }).then((r) => r.data);

export const adminGet = (path) => axios.get(`${API}${path}`, authHeader()).then((r) => r.data);
export const adminPut = (path, body) => axios.put(`${API}${path}`, body, authHeader()).then((r) => r.data);
export const adminPost = (path, body) => axios.post(`${API}${path}`, body, authHeader()).then((r) => r.data);
export const adminDelete = (path) => axios.delete(`${API}${path}`, authHeader()).then((r) => r.data);
export const adminGetBlob = (path) =>
  axios.get(`${API}${path}`, { ...authHeader(), responseType: "blob" }).then((r) => r.data);

export const adminUpload = (path, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios
    .post(`${API}${path}`, fd, { headers: { Authorization: `Bearer ${getToken()}`, "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};

export const forgotPassword = (email, baseUrl) =>
  axios.post(`${API}/admin/forgot-password`, { email, base_url: baseUrl }).then((r) => r.data);
export const resetPassword = (token, newPassword) =>
  axios.post(`${API}/admin/reset-password`, { token, new_password: newPassword }).then((r) => r.data);
